import { render, staticRenderFns } from "./MainBackground.vue?vue&type=template&id=d79d4564&scoped=true&"
import script from "./MainBackground.vue?vue&type=script&lang=js&"
export * from "./MainBackground.vue?vue&type=script&lang=js&"
import style0 from "./MainBackground.vue?vue&type=style&index=0&id=d79d4564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79d4564",
  null
  
)

export default component.exports